import React from "react";
import IconButton from "@mui/material/IconButton";

function DayCell({ dayNumberText }) {
  return (
    <div>
      <IconButton
        size="small"
        style={{
          fontSize: 12,
          fontWeight: 600,
          letterSpacing: 0.3,
          minWidth: 24,
          minHeight: 24,
          textAlign: "center",
        }}
        value="day"
      >
        {dayNumberText}
      </IconButton>
    </div>
  );
}

export default DayCell;
